import { css } from "@emotion/react";

export const ModalMemberVipMobileStyle = {
  modalWrap: css`
    .ant-modal {
      &-content {
        top: -93px;
        padding: 8px 8px 32px !important;
        border-radius: 10px !important;
        background-image: linear-gradient(
          72deg,
          #fdffd1 11%,
          #fefff0 84%,
          #fff 97%
        );
      }

      &-close {
        top: -35px;
        right: 0px;

        background-color: white;
        border-radius: 50%;
        color: black !important;
      }
    }
  `,

  wrapper: css``,

  header: css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    img {
      max-width: 40px;

      margin-right: 10px;
    }
    .ant-select {
      &-open {
        .ant-select-arrow {
          transform: rotate(180deg);
        }
      }
      &-selector {
        height: 24px !important;
        border-radius: 12px;
        border: solid 1px #ffcd51;
        background-image: linear-gradient(to bottom, #fefbb3, #ffcd51);
        outline: none;

        display: flex;
        align-items: center;
        span {
          color: #8b5211 !important;
          font-size: 12px;
          line-height: 24px;
          font-weight: 700;
        }
      }
      &-selection-item {
        height: 24px;
        padding-inline-end: 15px !important;

        font-weight: bold;
      }
    }
  `,

  mainContent: css`
    margin-bottom: 95px;
    table {
      width: 100%;
      margin-top: 10px;
      text-align: center;
      text-indent: 0;
      border-color: inherit;
      border-collapse: collapse;
      tr {
        border: 1px solid #f1da6f;
        th {
          width: 50%;
          line-height: 36px;
          border: 1px solid #f1da6f;
          background-image: linear-gradient(to bottom, #ffe980, #f1da6f);
        }
        td {
          width: 50%;
          line-height: 36px;
          border: 1px solid #f1da6f;
        }
      }
    }
  `,
};
